import CandidatesPage from './CandidatesPage'
import { candidatesMenu } from './sideBarOption'

export { candidatesMenu }
export default CandidatesPage
